module.exports = __webpack_public_path__ + "img/sp-chat-tel.b27885fd.png";